export const BUSINESS = {
  name: "Arjun Mehndi Arts",
  shortName: "Arjun Mehndi Arts",
  tagline: "Bridal & festive henna, hand-drawn since 2003",
  phoneDisplay: "+91 98766 59536",
  phone: "919876659536",
  instagram: "https://www.instagram.com/arjunmehandipathankot/",
  instagramHandle: "@arjunmehandipathankot",
  address: "Shop No. 25, Sant Nagar, Gandhi Chowk, Pathankot, Punjab 145001",
  mapQuery: "Arjun+Mehndi+Arts+Gandhi+Chowk+Pathankot+Punjab+145001",
  hours: "Open daily · Closes 10 PM",
  established: 2003,
  rating: "4.7",
  reviews: 124,
  yearsExperience: "20+",
};

export const whatsappLink = (text) =>
  `https://wa.me/${BUSINESS.phone}?text=${encodeURIComponent(
    text ||
      "Hi Arjun, I would like to book mehndi. Here are my details:\n\nName: \nEvent type (Bridal / Engagement / Party / Festive): \nEvent date: \nLocation / Venue: \nNumber of people: \nPreferred time: "
  )}`;

export const IMAGES = {
  heroPortrait:
    "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/ayscv382_WhatsApp%20Image%202026-08-03%20at%2017.23.34.jpeg",
  bridalDetail:
    "https://images.unsplash.com/photo-1732118400647-a81e3b37be87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxicmlkYWwlMjBtZWhuZGklMjBoYW5kc3xlbnwwfHx8fDE3ODU3NTAyMjB8MA&ixlib=rb-4.1.0&q=85",
  artistAtWork:
    "https://images.unsplash.com/photo-1782876224837-e7163083c4c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxoZW5uYSUyMGFydGlzdCUyMGFwcGx5aW5nfGVufDB8fHx8MTc4NTc1MDIyMHww&ixlib=rb-4.1.0&q=85",
  redDress:
    "https://images.unsplash.com/photo-1613665667184-81bb9b8605e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxicmlkYWwlMjBtZWhuZGklMjBoYW5kc3xlbnwwfHx8fDE3ODU3NTAyMjB8MA&ixlib=rb-4.1.0&q=85",
  vibrant:
    "https://images.unsplash.com/flagged/photo-1557695742-6ddd2cd63a5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwYnJpZGFsJTIwaGFuZHN8ZW58MHx8fHwxNzg1NzUwMjE5fDA&ixlib=rb-4.1.0&q=85",
  artistShop:
    "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/2w9k7xt6_WhatsApp%20Image%202026-08-03%20at%2017.15.41.jpeg",
};

export const SERVICES = [
  {
    id: "bridal",
    index: "01",
    title: "Bridal Mehndi",
    price: "Starting ₹2,100 / ₹3,100",
    desc: "Full-arm and full-leg bridal artistry with intricate portraits, motifs and the groom's name hidden within. A signature ceremony for your wedding day.",
    tags: ["Full hands & feet", "Portrait detailing", "Trial available"],
    image:
      "https://images.unsplash.com/photo-1732118400647-a81e3b37be87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxicmlkYWwlMjBtZWhuZGklMjBoYW5kc3xlbnwwfHx8fDE3ODU3NTAyMjB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "engagement",
    index: "02",
    title: "Engagement & Roka",
    price: "₹1,500 – ₹2,100",
    desc: "Elegant, refined patterns tailored for engagements, roka and sagan — balanced negative space with delicate finishing.",
    tags: ["Front & back hands", "Contemporary motifs"],
    image:
      "https://images.unsplash.com/photo-1702378154233-9b870ff8f1b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxicmlkYWwlMjBtZWhuZGklMjBoYW5kc3xlbnwwfHx8fDE3ODU3NTAyMjB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "arabic",
    index: "03",
    title: "Arabic & Indo-Arabic",
    price: "₹200 / ₹300 / ₹500",
    desc: "Bold, flowing floral trails with striking negative space — perfect for parties, sangeet and festive gatherings.",
    tags: ["Flowing florals", "Quick sittings"],
    image:
      "https://images.unsplash.com/flagged/photo-1557695742-6ddd2cd63a5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3ZWRkaW5nJTIwYnJpZGFsJTIwaGFuZHN8ZW58MHx8fHwxNzg1NzUwMjE5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "festive",
    index: "04",
    title: "Festive & Party",
    price: "₹300 – ₹800",
    desc: "Karva Chauth, Teej, Eid and family functions. Group bookings and on-location service across Pathankot.",
    tags: ["Group bookings", "On-location"],
    image:
      "https://images.unsplash.com/photo-1613665667184-81bb9b8605e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxicmlkYWwlMjBtZWhuZGklMjBoYW5kc3xlbnwwfHx8fDE3ODU3NTAyMjB8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const GALLERY = [
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/j6pjaqp1_WhatsApp%20Image%202026-08-03%20at%2017.56.53.jpeg",
    span: "tall",
    label: "Bridal full-arm — palace & doli",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/q27wuis0_WhatsApp%20Image%202026-08-03%20at%2017.56.54.jpeg",
    span: "normal",
    label: "Portrait bridal design",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/d12fhyss_WhatsApp%20Image%202026-08-03%20at%2017.56.54%20%281%29.jpeg",
    span: "tall",
    label: "Rajasthani dulha-dulhan motifs",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/cc2gyd67_WhatsApp%20Image%202026-08-03%20at%2017.56.55.jpeg",
    span: "normal",
    label: "Full-hand bridal artistry",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/0qb592vj_WhatsApp%20Image%202026-08-03%20at%2017.56.55%20%281%29.jpeg",
    span: "tall",
    label: "Personalised names & dates",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/3udkr4bf_WhatsApp%20Image%202026-08-03%20at%2017.56.50%20%282%29.jpeg",
    span: "tall",
    label: "Radha-Krishna & royal couple",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/3voeiesj_WhatsApp%20Image%202026-08-03%20at%2017.56.51.jpeg",
    span: "normal",
    label: "Peacock & temple motifs",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/nci4jlmv_WhatsApp%20Image%202026-08-03%20at%2017.56.51%20%281%29.jpeg",
    span: "tall",
    label: "Wedding phera storytelling",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/ghcj7rt2_WhatsApp%20Image%202026-08-03%20at%2017.56.51%20%282%29.jpeg",
    span: "normal",
    label: "Ganesh & wedding date design",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_mehandi-showcase-3/artifacts/jd9w6637_WhatsApp%20Image%202026-08-03%20at%2017.56.52.jpeg",
    span: "tall",
    label: "Full-arm portrait bridal",
  },
  {
    src: IMAGES.heroPortrait,
    span: "normal",
    label: "The artist at work",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Arjun ji did my bridal mehndi and it was beyond beautiful. The detail and the deep colour lasted for weeks. Truly the best in Pathankot.",
    name: "Simran K.",
    meta: "Bride, 2024",
  },
  {
    quote:
      "Booked him for our family's Karva Chauth. Punctual, calm, and every design was unique. Everyone kept asking who did our henna.",
    name: "Neha S.",
    meta: "Festive booking",
  },
  {
    quote:
      "20 years of experience really shows. Steady hands, gorgeous patterns and such a warm person. Highly recommend for weddings.",
    name: "Pooja R.",
    meta: "Engagement",
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "A craft, not a service",
    body:
      "Since 2003, Arjun has treated every palm as a canvas. What began in a small shop at Gandhi Chowk has become Pathankot's most trusted name in bridal henna — one steady line at a time.",
  },
  {
    no: "02",
    title: "The bride comes first",
    body:
      "Each design is drawn freehand, tailored to the bride's outfit, story and the little details she asks for — a hidden name, a favourite flower, a memory folded into motifs.",
  },
  {
    no: "03",
    title: "Colour that lasts",
    body:
      "Using natural, skin-safe henna and time-honoured technique, the stain deepens over 48 hours into a rich maroon that stays vivid well beyond the wedding day.",
  },
];
